(() => {
  let controller;
  function initialize() {
    controller?.abort();
    controller = new AbortController();
    const on = (element, event, callback) => element?.addEventListener(event, callback, { signal: controller.signal });
    const words = window.MM_TEXT || {};
    const toggle = document.getElementById('theme-toggle');
    function applyTheme(theme) {
      const dark = theme === 'dark';
      document.documentElement.dataset.theme = dark ? 'dark' : 'light';
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', String(dark));
      toggle.setAttribute('aria-label', dark ? words.switch_light : words.switch_dark);
      toggle.querySelector('b').textContent = dark ? words.light : words.dark;
    }
    applyTheme(document.documentElement.dataset.theme);
    on(toggle, 'click', () => {
      const theme = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
      applyTheme(theme);
      try { localStorage.setItem('mm-theme', theme); } catch {}
    });
    const canvas = document.getElementById('model-canvas');
    const layers = [...document.querySelectorAll('.model-layers button')];
    layers.forEach(button => on(button, 'click', () => {
      layers.forEach(item => { item.classList.toggle('active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
      if (canvas) canvas.className = 'model-canvas ' + button.dataset.layer;
    }));
    const tabs = [...document.querySelectorAll('.portfolio-tabs button')];
    tabs.forEach(button => on(button, 'click', () => {
      tabs.forEach(item => { item.classList.toggle('active', item === button); item.setAttribute('aria-selected', String(item === button)); });
      const image = document.getElementById('portfolio-image');
      if (image) { image.style.objectPosition = button.dataset.position; image.alt = button.dataset.title; }
      for (const [id, field] of [['portfolio-index', 'index'], ['portfolio-type', 'type'], ['portfolio-title', 'title'], ['portfolio-detail', 'detail']]) {
        const target = document.getElementById(id);
        if (target) target.textContent = field === 'index' ? 'Model preview / ' + button.dataset[field] : button.dataset[field];
      }
    }));
    const form = document.getElementById('quote-form');
    const steps = [...(form?.querySelectorAll('.quote-step') || [])];
    if (!form || !steps.length) return;
    form.noValidate = true;
    const progress = [...document.querySelectorAll('.quote-track > span')];
    const back = document.getElementById('quote-back');
    const next = document.getElementById('quote-next');
    const picker = document.getElementById('map-picker');
    const marker = document.getElementById('map-marker');
    const point = document.getElementById('map-position');
    const mapText = document.getElementById('map-selection');
    const field = name => form.elements.namedItem('contact[' + name + ']');
    const outside = field('outside_lower_48');
    const selected = name => [...form.querySelectorAll('input[name="' + name + '"]:checked')].map(input => input.value);
    const setText = (id, text) => { const target = document.getElementById(id); if (target) target.textContent = text; };
    let current = 0;
    let sending = false;
    let readyToSubmit = false;
    function summary() {
      setText('summary-asset', selected('contact[asset]')[0] || words.unconfirmed);
      setText('summary-location', field('location').value || words.unconfirmed);
      setText('summary-deliverables', selected('deliverables').join(' · ') || words.unconfirmed);
    }
    function show(index) {
      current = index;
      steps.forEach((step, number) => { step.classList.toggle('active', number === index); step.hidden = number !== index; });
      progress.forEach((item, number) => item.classList.toggle('done', number <= index));
      back.hidden = index === 0;
      next.textContent = index === steps.length - 1 ? words.submit + ' →' : words.continue + ' →';
      if (index === steps.length - 1) summary();
    }
    function validStep() { return [...steps[current].querySelectorAll('[required]')].every(input => input.reportValidity()); }
    function prepare() {
      const deliverables = selected('deliverables').join(', ');
      document.getElementById('quote-deliverables').value = deliverables;
      document.getElementById('quote-body').value = [
        'Movement Motion Technologies project request', 'Asset: ' + field('asset').value,
        'Deliverables: ' + deliverables, 'Location: ' + field('location').value,
        'Asset count / site size: ' + field('size').value, 'Map point: ' + point.value,
        'Outside lower 48: ' + (outside.checked ? 'Yes' : 'No'), 'Target date: ' + field('date').value,
        'Project notes: ' + field('notes').value, 'Name: ' + field('name').value,
        'Work email: ' + field('email').value, 'Company: ' + field('company').value,
        'Phone: ' + field('phone').value
      ].join('\n');
    }
    on(picker, 'click', event => {
      if (outside.checked) return;
      const rect = picker.getBoundingClientRect();
      const x = event.detail === 0 ? 50 : Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
      const y = event.detail === 0 ? 50 : Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100));
      marker.style.left = x + '%'; marker.style.top = y + '%'; marker.hidden = false;
      point.value = x.toFixed(1) + '% from west, ' + y.toFixed(1) + '% from north';
      mapText.textContent = words.map_selected + ' ' + point.value;
    });
    on(outside, 'change', () => {
      picker.disabled = outside.checked;
      picker.classList.toggle('disabled', outside.checked);
      if (outside.checked) { marker.hidden = true; point.value = ''; }
      mapText.textContent = outside.checked ? words.outside_map : words.no_map;
    });
    form.querySelectorAll('.option-grid input').forEach(input => on(input, 'change', () => {
      form.querySelectorAll('.option-grid label').forEach(label => label.classList.toggle('selected', label.querySelector('input').checked));
    }));
    on(back, 'click', () => show(Math.max(0, current - 1)));
    on(form, 'keydown', event => {
      if (event.key === 'Enter' && event.target.tagName === 'INPUT' && !['checkbox', 'radio'].includes(event.target.type)) { event.preventDefault(); next.click(); }
    });
    on(next, 'click', () => {
      if (sending || !validStep()) return;
      if (current < steps.length - 1) { show(current + 1); const legend = steps[current].querySelector('legend'); legend.tabIndex = -1; legend.focus(); return; }
      for (let i = 0; i < steps.length; i++) {
        if ([...steps[i].querySelectorAll('[required]')].some(input => !input.checkValidity())) { show(i); validStep(); return; }
      }
      prepare();
      if (window.Shopify?.designMode) { let notice = form.querySelector('.mm-form-status'); if (!notice) { notice = document.createElement('p'); notice.className = 'mm-form-status'; notice.setAttribute('role', 'status'); form.append(notice); } notice.textContent = words.preview_submit; return; }
      steps.forEach(step => { step.hidden = false; step.classList.add('active'); });
      readyToSubmit = true;
      form.requestSubmit();
    });
    on(form, 'submit', event => {
      if (sending) { event.preventDefault(); return; }
      if (!readyToSubmit) { event.preventDefault(); next.click(); return; }
      prepare(); sending = true; next.disabled = true; next.textContent = words.sending;
    });
    const firstInvalid = steps.findIndex(step => [...step.querySelectorAll('[required]')].some(input => !input.value));
    show(form.querySelector('.mm-form-errors') && firstInvalid >= 0 ? firstInvalid : 0);
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
})();
